/**
 * @generated SignedSource<<57f859662c6f3a27e2ee2217cb10a20a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useMarketContext_nftItem$data = {
  readonly contract: {
    readonly address: string | null;
    readonly name: string | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly recentAuction: {
    readonly auctionId: number | null;
    readonly contractAddress: {
      readonly address: string | null;
    } | null;
    readonly status: NftAuctionStatus | null;
  } | null;
  readonly tokenId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_nftItem">;
  readonly " $fragmentType": "useMarketContext_nftItem";
};
export type useMarketContext_nftItem$key = {
  readonly " $data"?: useMarketContext_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketContext_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMarketContext_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketSettings_nftItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "recentAuction",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeCanceled",
          "value": true
        }
      ],
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "auctionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "contractAddress",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "mostRecentAuction(excludeCanceled:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "f972ad4f27d691c39e04b6857e6d5ff1";

export default node;
